import React, { useEffect, useState } from "react";
import { List, Card, Typography, Spin, Empty } from "antd";
import dataService from "../networks/api/service/dataService";

const { Title, Text } = Typography;

function TodaysEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDailyEvents = async () => {
      setLoading(true);
    
      try {
        const currentDate = new Date().toISOString().split("T")[0];
        const payload = { eventDate: currentDate };
    
        const response = await dataService.fetchEvents("daily", payload);
    
        console.log("API Response:", response); 

        if (response.code === 200 && response.data) {
          setEvents(response.data);  
        } else {
          setEvents([]);
        }
      } catch (error) {
        console.error("Error fetching daily events:", error);
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDailyEvents();
  }, []);

  return (
    <div style={{
      padding: "40px 24px",
      maxWidth: "900px",
      margin: "0 auto",
      maxHeight: "80vh",  // Limits the height
      overflowY: "auto",  // Enables vertical scrolling
    }}>
      <Title level={2} style={{ textAlign: "center", color: "#1890ff", marginBottom: "30px" }}>
      Today's Events
      </Title>

      {loading ? (
        <Spin size="large" style={{ display: "block", margin: "50px auto" }} />
      ) : events.length > 0 ? (
        <List
          grid={{ gutter: 16, column: 2 }}
          dataSource={events}
          renderItem={(event) => (
            <List.Item>
              <Card
                title={<Title level={4} style={{ margin: 0, color: "#333", textDecoration: "underline" }}>Event : {event.eventName}</Title>}
                bordered={false}
                style={{
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: "12px",
                  padding: "20px",
                  background: "#f9f9f9",
                  transition: "transform 0.3s ease",
                  maxWidth: "100%", // Control the card width
                  margin: "20px auto", // Center the card
                  border: "1px solid #e8e8e8" // Optional border for a card-like look
                }}
                hoverable
              >
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <Text strong style={{ fontSize: "16px", color: "#555" }}>Date: {new Date(event.eventDate).toLocaleDateString()}</Text> 
                  <Text strong style={{ fontSize: "16px", color: "#555" }}>Time: {event.eventTime}</Text> 
                  <Text strong style={{ fontSize: "16px", color: "#555" }}>Description: {event.eventDescription || "No description provided"}</Text> 
                  <Text strong style={{ fontSize: "16px", color: "#555" }}>Organizer: {event.eventOrganizer || "N/A"}</Text>
                </div>
              </Card>
            </List.Item>
          )}
        />
      ) : (
        <Empty 
          description="No events available" 
          style={{ marginTop: "50px" }} 
          image={Empty.PRESENTED_IMAGE_SIMPLE} 
        />
      )}
    </div>
  );
}

export default TodaysEvents;
